import React from 'react'
import { PickingReportProvider } from '../../components/PickingReport/provider/OtInboundDifference'
import { PickingReportWrapper } from '../../components/PickingReport/screens/PickingReportWrapper'

/*
Copyright 2022-06-08 por Jorge Parrado Ecomsur Holding S.A ©
Detalle: Crea reporte de picking
*/

export const PickingReportPage = () => {
  return (
    <PickingReportProvider>
      <PickingReportWrapper />
    </PickingReportProvider>
  )
}
